import { createApp } from '@backstage/frontend-defaults';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import { catalogPlugin } from '@backstage/plugin-catalog';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import { addAPIProvider } from '@iconify/react';
import { ipenPlugin } from '@ipen-portal/plugin-ipen';
import userPlugin from '@ipen-portal/plugin-user';
import { externalRoutes as userExternalRoutes } from '@ipen-portal/plugin-user-react';

import { GitlabPlugin, KubernetesPlugin, PrometheusPlugin } from './patches';

addAPIProvider('', {
  resources: ['https://icons.ipen.eon.com'],
});

const app = createApp({
  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, {
      createComponent: scaffolderPlugin.routes.root,
      createFromTemplate: scaffolderPlugin.routes.selectedTemplate,
      viewTechDoc: techdocsPlugin.routes.docRoot,
    });
    bind(apiDocsPlugin.externalRoutes, {
      registerApi: catalogImportPlugin.routes.importPage,
    });
    bind(ipenPlugin.externalRoutes, {
      catalogIndex: catalogPlugin.routes.catalogIndex,
      createComponent: scaffolderPlugin.routes.root,
      registerApi: catalogImportPlugin.routes.importPage,
      userSettings: userPlugin.routes.settings,
    });
    bind(scaffolderPlugin.externalRoutes, {
      registerComponent: catalogImportPlugin.routes.importPage,
    });
    bind(userPlugin.externalRoutes, {
      catalogEntity: catalogPlugin.routes.catalogEntity,
    });
    bind(userExternalRoutes, {
      catalogEntityRouteRef: catalogPlugin.routes.catalogEntity,
      settingsRouteRef: userPlugin.routes.settings,
    });
  },
  features: [GitlabPlugin, KubernetesPlugin, PrometheusPlugin],
});

// eslint-disable-next-line import-x/no-default-export
export default app.createRoot();
